import BaseViewModel from './BaseViewModel';

class TitleControlViewModel extends BaseViewModel {
	Validate = () => {
		return true;
	};
	getSimpleFormatXmlTagName = () => {
		return 'Title';
	};
}

export default TitleControlViewModel;
